import { render } from "./TeacherDetails.vue?vue&type=template&id=13ee09a4&scoped=true"
import script from "./TeacherDetails.vue?vue&type=script&lang=js"
export * from "./TeacherDetails.vue?vue&type=script&lang=js"

import "./TeacherDetails.vue?vue&type=style&index=0&id=13ee09a4&scoped=true&lang=css"

import exportComponent from "/home/runner/work/vue-soft/vue-soft/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13ee09a4"]])

export default __exports__